import React from 'react';
import { ShieldAlert } from 'lucide-react';

import { formatDate } from '../../utils/dateUtils';
import { StatusBadge } from '../UI/StatusBadge';

const ContinuousHomeLeaveBlocker = ({ policy }) => {
  if (!policy?.is_blocked) return null;

  const annualPeriods = policy.annual_leave_periods || [];

  return (
    <div
      className="rounded-xl border border-red-200 bg-red-50 p-4 shadow-sm"
      role="alert"
      aria-labelledby="continuous-home-leave-title"
    >
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
          <ShieldAlert className="h-5 w-5 text-red-600" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <h4
            id="continuous-home-leave-title"
            className="text-sm font-semibold text-red-900"
          >
            Continuous Home Leave limit
          </h4>
          <p className="mt-1 text-sm leading-relaxed text-red-800">
            {policy.summary}
          </p>
        </div>
      </div>

      <dl className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-3">
        <div className="rounded-lg border border-red-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-red-700">
            Linked Annual Leave
          </dt>
          <dd className="mt-1.5 space-y-1.5 text-sm font-medium text-gray-900">
            {annualPeriods.map((period, index) => (
              <div
                key={period.id || `${period.start_date}-${period.end_date}-${index}`}
                className="flex flex-wrap items-center gap-1.5"
              >
                <span>
                  {formatDate(period.start_date)} → {formatDate(period.end_date)}
                </span>
                {period.is_proposed ? (
                  <span className="text-xs font-medium text-red-700">Selected dates</span>
                ) : (
                  <StatusBadge status={period.status} />
                )}
              </div>
            ))}
          </dd>
        </div>

        <div className="rounded-lg border border-red-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-red-700">
            Combined absence
          </dt>
          <dd className="mt-1.5 text-sm font-medium text-gray-900">
            {formatDate(policy.trip_start_date)} → {formatDate(policy.trip_end_date)}
          </dd>
          <dd className="mt-0.5 text-xs font-semibold text-red-700">
            {policy.combined_calendar_days} calendar days
          </dd>
        </div>

        <div className="rounded-lg border border-red-200 bg-white p-3">
          <dt className="text-xs font-semibold uppercase tracking-wide text-red-700">
            Maximum allowed
          </dt>
          <dd className="mt-1.5 text-sm font-semibold text-red-900">
            {policy.maximum_calendar_days} calendar days
          </dd>
          <dd className="mt-0.5 text-xs text-red-700">
            One continuous Home Leave absence
          </dd>
        </div>
      </dl>

      <div className="mt-4 border-t border-red-200 pt-3">
        <p className="text-sm leading-relaxed text-red-800">
          <span className="font-semibold">What to do:</span>{' '}
          {policy.corrective_action}
        </p>
      </div>
    </div>
  );
};

export default ContinuousHomeLeaveBlocker;
